/**
 * Configuração de ambiente.
 *
 * Tudo aqui é `VITE_*`, resolvido em build-time pelo Vite — variável de
 * ambiente no Pod não tem efeito em runtime (ver `ci/prod-values.yaml`).
 */

const env = import.meta.env;

function texto(valor: unknown, padrao: string): string {
  return typeof valor === 'string' && valor.trim() !== '' ? valor.trim() : padrao;
}

function lista(valor: unknown, padrao: string[]): string[] {
  if (typeof valor !== 'string') return padrao;
  return valor
    .split(',')
    .map((item) => item.trim())
    .filter(Boolean);
}

export const config = {
  /**
   * `rest` fala com a API do Compilações autenticando no Keycloak (padrão, é o
   * que roda em produção). `demo` roda offline com versões reais de exemplo,
   * para trabalhar em tela sem depender de login nem de backend.
   */
  dataSource: (env.VITE_DATA_SOURCE as 'rest' | 'demo' | undefined) === 'demo' ? ('demo' as const) : ('rest' as const),

  /**
   * Base da API do Compilações, SEM o `/v1` (as rotas do contrato já começam
   * com ele — ver `docs/CONTRATO.md`).
   *
   * Em desenvolvimento o padrão é `/compilacoes-api`, servido pelo proxy do
   * Vite (que só remove o prefixo e repassa para a API local na 8000). Em
   * produção vale a URL absoluta do Gateway, com `root_path` `/compilacoes`.
   */
  /**
   * Repositório Maven do Nexus de onde o instalador resolve os artefatos (`<repository><id>nasajon</id>` do
   * `erp-instalador/build/pom.xml`). O botão de copiar do manifesto monta o link de download a partir dele.
   */
  nexusUrl: texto(env.VITE_NEXUS_URL, 'https://nexus.nasajon.com.br/repository/erp'),

  apiBaseUrl: texto(env.VITE_API_URL, env.DEV ? '/compilacoes-api' : 'https://api.nasajon.in/compilacoes'),

  keycloak: {
    url: texto(env.VITE_KEYCLOAK_URL, 'https://auth.nasajon.com.br/auth'),
    realm: texto(env.VITE_KEYCLOAK_REALM, 'master'),
    clientId: texto(env.VITE_KEYCLOAK_CLIENTID, 'compilacoes-app'),
  },

  /** Capabilities simuladas no modo demo — vazio mostra tudo bloqueado com cadeado. */
  demoCapabilities: lista(env.VITE_DEMO_CAPABILITIES, ['maintainer', 'painel', 'admin']),

  /** Simula colaborador (@nasajon.com.br, padrão) ou cliente externo (`false`) no modo demo. */
  demoColaborador: texto(env.VITE_DEMO_COLABORADOR, 'true').toLowerCase() !== 'false',

  /** Latência simulada da fonte demo (ms). Os testes zeram. */
  demoLatenciaMs: Number(texto(env.VITE_DEMO_LATENCIA_MS, '280')) || 0,

  basePath: '/',
} as const;

/** Produto padrão do contrato — o único que o Jenkins publica hoje. */
export const PRODUTO_PADRAO = 'instalador-erp';

/** Rótulos legíveis dos produtos conhecidos; produto novo cai no próprio id. */
export const PRODUTOS: Record<string, string> = {
  'instalador-erp': 'Instalador ERP',
};
